import { ChangeDetectionStrategy, Component, inject, model, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ListViewCuListItem } from '@app/layout/sidebar/components/listview-cu/list-view-cu-list-item/list-view-cu-list-item'
import { ContentUnitStateService } from '../../services/content-unit-state.service'
import { ContentSidebarListViewComponent } from '../content-sidebar-list-view/content-sidebar-list-view.component'

@Component({
  selector: 'albert-listview-cu',
  standalone: true,
  imports: [CommonModule, ListViewCuListItem, ContentSidebarListViewComponent],
  templateUrl: './list-view-cu.component.html',
  styleUrl: './list-view-cu.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListViewContentUnitComponent implements OnInit {
  public readonly itemSize = 195
  public readonly sidebarDrawerVisible = model(false)
  public readonly contentUnitState = inject(ContentUnitStateService)

  public ngOnInit(): void {
    this.contentUnitState.reload(20).subscribe()
  }
}
